import {useUpmPlant} from '@hconnect/upm'

import {useUrlParam} from '../routing/hooks'

import {KilnOverviewCard, KilnShutdownsCard} from './components'
import {useKilnConfig, useKilnDrillingSettingsQuery} from './hooks/queries'
import {KilnSettingsProvider} from './providers'

import {useKilns} from '@refra/modules/common/providers'

export const RefraPlanningBody: React.FC = () => {
  const plantId = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId})
  const {selectedKiln} = useKilns()

  const {data: kilnConfig} = useKilnConfig({
    plantUpmId: upmPlant.upmId,
    kilnUpmId: selectedKiln.upmId
  })

  const {data: drillingSettings} = useKilnDrillingSettingsQuery({
    plantUpmId: upmPlant.upmId,
    kilnUpmId: selectedKiln.upmId
  })

  if (!kilnConfig || !drillingSettings) {
    throw new Error('Kiln config and drilling settings must be fetched beforehand!')
  }

  return (
    <KilnSettingsProvider kilnConfig={kilnConfig} drillingSettings={drillingSettings}>
      <div className="flex flex-col gap-6">
        <KilnOverviewCard />
        <KilnShutdownsCard />
      </div>
    </KilnSettingsProvider>
  )
}
